import animateScrollTo from "animated-scroll-to";

export const donatePlan = function (el) {
    const index = el.getAttribute("data-index");
    document.querySelector(".donate-block-frames").style.display = "block";
    document
        .querySelectorAll(".donate-block-frames__frame")
        .forEach(function (frame) {
            frame.style.display = "none";
        });
    document.querySelector(".donate-block-frames .d-" + index).style.display =
        "block";
    document.querySelector(".donate-block-choice").style.display = "none";
    document.querySelector(
        ".donate-block-frames .d-" + index + " iframe"
    ).style.width = "100%";
    setTimeout(function () {
        animateScrollTo(document.querySelector(".donate-block-frames"), {
            easing: (t) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t),
            minDuration: 1000,
            maxDuration: 2000,
            speed: 1000,
        });
    }, 500);
};

export const donateOnce = function (el) {
    const index = el.getAttribute("data-index");
    document.querySelector(".donate-once-block-forms").style.display = "block";
    document
        .querySelectorAll(".donate-once-block-form")
        .forEach(function (frame) {
            frame.style.display = "none";
        });
    document.querySelector(".donate-once-block-form-" + index).style.display =
        "block";
    document.querySelector(".donate-once-block-choice").style.display = "none";
};
